import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

// Component
import DashboardPopOver from "../../../component/DashboardPopOver";
import { useDispatch, useSelector } from "react-redux";
import {
  addToMyDashboard,
  deleteWidgets,
} from "../../../redux/actions/analytics";
import { createColorPalette } from "../../../utils";

function DonutChart({
  id,
  title,
  menu,
  data,
  isDisable,
  setUpdate,
  update,
  tab,
}) {
  const dispatch = useDispatch();
  const { color_palettes } = useSelector((state) => state.palettes);

  const [graphData, setGraphData] = useState([]);
  const [activeData, setActiveData] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [colors, setColors] = useState([]);

  useEffect(() => {
    if (data) {
      const chartData = data.map((item) => {
        item.value = Number(item.value);
        return item;
      });
      setColors(createColorPalette(chartData.length, Object.values(color_palettes)));
      setGraphData(chartData);
    }
  }, [data]);

  // Add To My Dashboard
  const handleAddToMyDashboard = () => {
    const request = {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
      payload: {
        analytic_widget_id: id.analytic_widget_id,
      },
    };

    dispatch(addToMyDashboard(request));
  };

  // Delete Widget
  const handleDeleteWidgets = () => {
    const request = {
      dashboard_widget_id: id.analytic_dashboard_id,
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
    };

    dispatch(deleteWidgets(request));
  };

  const handleMouseEnter = (data, index) => {
    setActiveData(data);
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveData(null);
    setActiveIndex(null);
  };

  return (
    <div className="h-full w-full">
      <div className="absolute top-1 right-2 text-base text-[#7D8490]">
        <DashboardPopOver
          menus={menu}
          handleOnClick={() =>
            tab ? handleDeleteWidgets() : handleAddToMyDashboard()
          }
          isDisable={isDisable}
        />
      </div>

      <div className="h-full w-full space-y-2">
        <h2 className="text-sm font-semibold text-[#313439] leading-5">
          {title}
        </h2>
        {graphData?.length > 0 ? (
          <div className="w-full h-[85%]">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={graphData}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={80}
                  // fill="#8884d8"
                  dataKey="value"
                  nameKey="name"
                  paddingAngle={0}
                  startAngle={90}
                  endAngle={-270}
                  // label={renderCustomizedLabel}
                  labelLine={false}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  {graphData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={activeIndex === index ? "#faac1f" : colors[index]}
                    />
                  ))}
                </Pie>
                {activeData && (
                  <g>
                    <text
                      x="50%"
                      y="50%"
                      textAnchor="middle"
                      fill="#535860"
                      fontSize={10}
                      fontWeight={500}
                    >
                      {activeData.name}
                    </text>
                    <text
                      x="50%"
                      y="60%"
                      textAnchor="middle"
                      fill="#535860"
                      fontSize={10}
                      fontWeight={700}
                    >
                      {activeData.value}%
                    </text>
                  </g>
                )}
              </PieChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <div className="h-[85%] flex justify-center items-center text-sm font-semibold leading-5 capitalize">
            No Data Found
          </div>
        )}
      </div>
    </div>
  );
}

export default DonutChart;
